import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function SearchInput(props) {
    const { t } = useTranslation();

    return (
        <TextField
            className={props.class || undefined}
            sx={!props.class ? { mx: 1, width: '95%', mt: '10px' } : undefined}
            placeholder={props.placeholder ? props.placeholder : t('searchHint')}
            value={props.searchInput}
            onChange={props.onChange}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
            }}
            variant="standard"
        />
    );
}

SearchInput.propTypes = {
    searchInput: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    class: PropTypes.object,
};
